import { ArrowUpRight, ChevronDown } from "lucide-react";
import { useState } from "react";
import { chapters } from "@/content";
import { Reveal } from "@/components/Reveal";

export default function ChaptersSection() {
  const [active, setActive] = useState(0);
  const chapter = chapters[active];

  return (
    <section className="section chapters-section" id="capitulos" data-testid="chapters-section">
      <div className="section-shell">
        <Reveal className="section-heading-row chapters-heading">
          <div><p className="eyebrow">O ÍNDICE COMPLETO</p><h2>Sete capítulos. Trinta páginas. Um roteiro para colocar em prática.</h2></div>
          <a href="#oferta" className="inline-link" data-testid="chapters-offer-link">Ver o que está incluído <ArrowUpRight size={16} /></a>
        </Reveal>
        <div className="chapters-layout">
          <div className="chapter-list" role="list">
            {chapters.map((item, index) => <Reveal key={item.number} delay={index * 45}><button type="button" className={`chapter-row ${active === index ? "is-active" : ""}`} onClick={() => setActive(index)} aria-expanded={active === index} data-testid={`chapter-item-${index + 1}`}><span className="chapter-index">{item.number}</span><span className="chapter-name"><small>{item.pages}</small><strong>{item.title}</strong></span><ChevronDown size={18} className="chapter-chevron" /></button></Reveal>)}
          </div>
          <Reveal className="chapter-detail" delay={150}>
            <p className="eyebrow">{chapter.number} · {chapter.pages}</p>
            <h3>{chapter.title}</h3>
            <p>{chapter.summary}</p>
            <div className="detail-takeaway"><span>AO FINAL, VOCÊ TERÁ</span><strong>{chapter.takeaway}</strong></div>
            <blockquote>“{chapter.verse}”</blockquote>
            <button type="button" className="detail-link" onClick={() => document.getElementById("oferta")?.scrollIntoView({ behavior: "smooth" })} data-testid="open-sample-reading-modal">Ler o livro completo <ArrowUpRight size={16} /></button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
